import { adminApi } from './ApiService';

class ClientService {
  // ── Warranties ─────────────────────────────────────────
  async listWarranties(clientId) {
    const params = clientId ? { clientId } : {};
    return adminApi.get('/admin/warranties', params);
  }

  async createWarranty(data) {
    return adminApi.post('/admin/warranties', data);
  }

  async updateWarranty(id, data) {
    return adminApi.patch(`/admin/warranties/${id}`, data);
  }

  async deleteWarranty(id) {
    return adminApi.delete(`/admin/warranties/${id}`);
  }

  // ── Client Notes (CRM) ────────────────────────────────
  async listClientNotes(clientId) {
    const params = clientId ? { clientId } : {};
    return adminApi.get('/admin/client-notes', params);
  }

  async createClientNote(data) {
    return adminApi.post('/admin/client-notes', data);
  }

  async deleteClientNote(id) {
    return adminApi.delete(`/admin/client-notes/${id}`);
  }

  // ── Reportes de telemetria ────────────────────────────
  /** Lista los reportes (S3) de un cliente con URLs de descarga presignadas. */
  async listReports(clientId) {
    return adminApi.get(`/admin/clients/${clientId}/reports`);
  }

  /**
   * Dispara la generacion on-demand de reportes de un cliente.
   * opts opcional: { roomId, year, month|quarter, sendEmail }
   */
  async generateReports(clientId, opts = {}) {
    return adminApi.post(`/admin/clients/${clientId}/reports/generate`, opts);
  }
}

export default new ClientService();
